import commissioner_template from './templates/commissioner_template.jst';
import non_commissioner_template from './templates/non_commissioner_template.jst';
import './index.styl';
import { CoreLeagueSettingsView } from '../../../../../core/views';
import { redirectTo } from '../../../utils';

/**
 * @desc League Settings View Class
 * This class using on league settings page ('comps/:league_id/manage')
 */
export default class CompsSettingsView extends CoreLeagueSettingsView {
	get className() {
		return "league-settings-page shadow";
	}

	getTemplate() {
		if ( !this.is_commissioner ) {
			return non_commissioner_template;
		}
		else {
			return commissioner_template;
		}
	}

	/**
	 * Get all base data for this class
	 * @returns {*|Promise.<Object>}
	 */
	fetchData() {
		return Promise.all( [
			this.rounds.fetch(),
			this.model.setShowUrl().fetch(
				{
					data: {
						id: this.league_id
					}
				}
			),
			this.teams.show_my( {
				id:     this.league_id,
				offset: 0,
				limit:  this.teams.default_offset
			} )
		] );
	}

	loadMoreTeam() {
		this.offset += this.teams.default_offset;
		this.oldTeamList = this.teams.toJSON();

		this.getMoreTeams({
			offset:    this.offset,
			id: this.league_id,
			limit:  this.teams.default_offset
		});
	}

	redirectToMyLeague() {
		redirectTo( '/comps/my-comps' );
	}

	get removeTeamDataTeamKey() {
		return 'user_id';
	}

	get removeTeamDataLeagueKey() {
		return 'comp_id';
	}

	get updateTeamsData() {
		return {
			id: this.league_id,
			offset: 0,
			limit:  this.teams.default_offset + this.offset
		}
	}

	removeTeamFromLeague( element ) {
		let team_id = $(element.currentTarget).data('id');
		let confirm_remove = confirm("Are you sure you want to delete this team ?");

		if( confirm_remove ) {
			$(element.currentTarget).closest('.table-row-item').hide();

			let data = {
				[this.removeTeamDataTeamKey]:team_id,
				[this.removeTeamDataLeagueKey]: this.model.get( 'id' )
			};

			this.teams.removeTeam( data );
		}
	}

	get remove_text() {
		return "Are you sure you want to delete this comp ?";
	}
}